import { AgenciesHome } from 'containers/Agencies/AgenciesHome';
import { AgenciesModel } from 'containers/Agencies/AgenciesModel';
import { AgencyDetail } from 'containers/Agencies/AgencyDetail';
import { ROUTE_PATH } from 'enum/RoutePath';
import React, { useCallback } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import styles from './restaurants.module.scss';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { isRoles } from 'core/permission/PermissionDSL';
import { RoleNames } from 'core';

export const Restaurants: React.FC<{
  model: AgenciesModel;
}> = ({ model }) => {
  const renderRestaurantDetailView = useCallback(
    (props) => {
      if (model.canViewAgency()) {
        const defaultAgencyDetailModel = model.getAgencyDetailModel(
          parseInt(props.match.params.restaurantId, 10)
        );
        defaultAgencyDetailModel.isSystemViewOnly = model.isSystemViewOnly;
        const renderRedirect = () => (
          <Redirect to={`${props.match.url}/${ROUTE_PATH.ERROR403}`} />
        );
        return (
          <PermissionChecker
            permissionAware={isRoles(RoleNames.beaconAdmin)}
            renderOtherwise={renderRedirect}
          >
            <AgencyDetail model={defaultAgencyDetailModel} />
          </PermissionChecker>
        );
      }
      return <Redirect push to={`${props.match.url}/${ROUTE_PATH.ERROR403}`} />;
    },
    [model]
  );

  const renderRestaurantHome = useCallback(() => {
    if (model.canViewAllAgencies) {
      return <AgenciesHome model={model.getAgenciesHomeModel()} />;
    } else if (model.isAgencyView && model.operatorAgencyPath) {
      return <Redirect push to={model.operatorAgencyPath} />;
    }
    return <Redirect push to={`/restaurants/${ROUTE_PATH.ERROR403}`} />;
  }, [model]);

  return (
    <div className={styles.restaurants}>
      <Switch>
        <Route
          path={'/restaurants/:restaurantId'}
          render={renderRestaurantDetailView}
        />
        <Route render={renderRestaurantHome} />
      </Switch>
    </div>
  );
};
